<div class="ledger-screen">
  <div class="ledger-header">
    <h1>Ledger</h1>
    <p>Search posted ledger entries, check balances, and trace each entry back to its source.</p>
  </div>

  @if (Loading) {
  <p class="no-access" role="status">Checking your access…</p>
  } @else if (CanView) {
  <rms-tab-group>
    <rms-tab label="Ledger Inquiry">
      <ng-template>
        <app-ledger-inquiry></app-ledger-inquiry>
      </ng-template>
    </rms-tab>
    <rms-tab label="Journal Review">
      <ng-template>
        <app-journal-review [canPrepare]="!!Roles?.preparer"></app-journal-review>
      </ng-template>
    </rms-tab>
    <rms-tab label="Recycle Bin">
      <ng-template>
        <app-recycle-bin></app-recycle-bin>
      </ng-template>
    </rms-tab>
    <rms-tab label="Periods">
      <ng-template>
        <app-accounting-periods [canManage]="!!Roles?.periodOwner"></app-accounting-periods>
      </ng-template>
    </rms-tab>
    <rms-tab label="Unresolved Payment Codes">
      <ng-template>
        <app-ledger-unresolved></app-ledger-unresolved>
      </ng-template>
    </rms-tab>
  </rms-tab-group>
  } @else {
  <p class="no-access" role="status">
    {{ AccessMessage || "You don't have access to the Ledger." }}
    @if (Denied) { Ask an administrator to add you to an Accounting group. }
  </p>
  }
</div>
